import { render, staticRenderFns } from "./ResetPasswordForm.vue?vue&type=template&id=6dbb8bea&scoped=true"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=ts"
import style0 from "./ResetPasswordForm.vue?vue&type=style&index=0&id=6dbb8bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbb8bea",
  null
  
)

export default component.exports